var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfitabilitate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Iconi\u021B\u0103 grafic de cre\u0219tere") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Iconi\u021B\u0103 SVG cu monede stivuite, bar\u0103 vertical\u0103 \u0219i s\u0103geat\u0103 ascendent\u0103.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 5,
    floodOpacity: 0.18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103 296 L222 177 L282 237 L409 110",
    fill: "none",
    stroke: "#5b2a6d",
    strokeWidth: 42,
    strokeLinecap: "square",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 82 L457 66 L441 142 Z",
    fill: "#5b2a6d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5b2a6d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 327c0-16 27-29 61-29s61 13 61 29v64c0 16-27 29-61 29s-61-13-61-29z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 147,
    cy: 327,
    rx: 61,
    ry: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 351c10 13 34 21 61 21s51-8 61-21",
    fill: "none",
    stroke: "#f2eff4",
    strokeWidth: 8,
    strokeLinecap: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 378c10 13 34 21 61 21s51-8 61-21",
    fill: "none",
    stroke: "#f2eff4",
    strokeWidth: 8,
    strokeLinecap: "round",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#5b2a6d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205 278c0-16 27-29 61-29s61 13 61 29v116c0 16-27 29-61 29s-61-13-61-29z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 266,
    cy: 278,
    rx: 61,
    ry: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 302c10 13 34 21 61 21s51-8 61-21",
    fill: "none",
    stroke: "#f2eff4",
    strokeWidth: 8,
    strokeLinecap: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 329c10 13 34 21 61 21s51-8 61-21",
    fill: "none",
    stroke: "#f2eff4",
    strokeWidth: 8,
    strokeLinecap: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 356c10 13 34 21 61 21s51-8 61-21",
    fill: "none",
    stroke: "#f2eff4",
    strokeWidth: 8,
    strokeLinecap: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 383c10 13 34 21 61 21s51-8 61-21",
    fill: "none",
    stroke: "#f2eff4",
    strokeWidth: 8,
    strokeLinecap: "round",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 183,
    width: 82,
    height: 237,
    rx: 10,
    fill: "#292d36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfitabilitate);
export default __webpack_public_path__ + "static/media/IconProfitabilitate.ec20d47af0debffb8debb36034f3a4e4.svg";
export { ForwardRef as ReactComponent };